import { TESTDATA_MODAL } from '@enums/overlay-internal-events.enum';
import { TEST_DATA_SYMBOLS } from '@enums/test-data-symbols.enum';
import PhoneNumberService from '@services/phone-number.service';
import {
  useInternalEvents,
  useTranslation,
  useAnimatedClass,
} from '@testsigma/atoms';

import { PhoneNumberSelector } from '@testsigma/organism';
import { useCallback, useState } from 'react';
import {
  TestDataDrawerHelpInfoProps,
  TestDataDrawerLayout,
} from './test-data-drawer-layout';
import classNames from 'classnames';
import { useInfiniteQuery } from 'react-query';
import { useReactQueryCaching } from '@hooks/use-react-query-caching';
import { CachingPrefix } from '@enums/caching-prefix.enum';

export const PhoneNumberDrawer = ({ isInsideRestApi = false }) => {
  const { t } = useTranslation();
  const publishInternalEvents = useInternalEvents([]);
  const { getCachingTime } = useReactQueryCaching(
    CachingPrefix.FETCH_TESTDATA_PHONENUMBER,
    false,
  );
  const [searchTerm, setSearchTerm] = useState('');
  const onClose = useCallback(
    () =>
      publishInternalEvents(
        TESTDATA_MODAL.CLOSE_PHONE_NUMBER,
        isInsideRestApi ? { isInsideRestApi: true } : null,
      ),
    [publishInternalEvents],
  );

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    [`${CachingPrefix.FETCH_TESTDATA_PHONENUMBER}-${searchTerm || ''}`],
    async ({ pageParam = 0 }) => {
      let query = `${searchTerm ? `phoneNumber:*${searchTerm}*` : ''}`;
      let checkData = await PhoneNumberService.findAll(query, 20, pageParam);
      return checkData;
    },

    {
      getNextPageParam: (lastPage) =>
        lastPage?.last ? undefined : lastPage?.pageable?.pageNumber + 1,
      staleTime: getCachingTime(),
      cacheTime: getCachingTime(),
    },
  );

  const modifiedData = data?.pages?.flatMap((item) => item?.content) || [];
  const onDataClick = useCallback(
    (item) => {
      publishInternalEvents(TESTDATA_MODAL.SELECTED_PHONE_NUMBER, item);
    },
    [publishInternalEvents],
  );

  const helpInfoProps: TestDataDrawerHelpInfoProps = {
    description: t('modal.help.phone_number'),
    url: 'https://testsigma.com/docs/test-data/types/phone-number/',
  };

  const animationClass = useAnimatedClass('reval-animation-opacity');

  return (
    <TestDataDrawerLayout
      title={t('modal.title.phone_number')}
      symbol={TEST_DATA_SYMBOLS.PHONE_NUMBER}
      onClose={onClose}
      helpInfo={helpInfoProps}
    >
      <div className={classNames('px-5 py-6 h-full', animationClass)}>
        <PhoneNumberSelector
          phoneNumbers={modifiedData}
          onClick={onDataClick}
          isFetching={isFetching}
          onChangeSearch={setSearchTerm}
          searchTerm={searchTerm}
          hasMore={hasNextPage}
          handleLoadMore={fetchNextPage}
        />
      </div>
    </TestDataDrawerLayout>
  );
};
